import React from "react";
import { Button } from "@mui/material";
import { useFormik, FormikProvider } from "formik";
import { Box } from "@mui/material";
import StackTelasFormFields from "./StackTelasFormFields";
import { createRolls, modifyRolls } from "../functions";
import { useSelector, useDispatch } from "react-redux";
import { showMessage } from "store/modules/Message";

const StackTelasForm = ({ mode, handleClose }) => {
  const { defaultData } = useSelector(({ talla }) => talla);
  const dispatch = useDispatch();

  const messages = (text) => {
    dispatch(
      showMessage({
        message: text,
        variant: "success",
        anchorOrigin: { vertical: "top", horizontal: "right" },
      })
    );
  };

  const formik = useFormik({
    initialValues:
      mode === "POST"
        ? { color: "", totalKg: "", meters: "", code: "", is_void: false }
        : defaultData,
    onSubmit: async (values) => {
      switch (mode) {
        case "POST":
          await createRolls(values);
          messages("El rollo se ha creado con éxito");
          break;
        case "PUT":
          await modifyRolls(values);
          messages("El rollo se ha editado con éxito");
          break;
        default:
          break;
      }
      handleClose();
    },
  });

  const { setFieldValue } = formik;

  return (
    <FormikProvider value={formik}>
      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          background: "#fafafa",
          ".dark &": { background: "#0f172a" },
        }}
      >
        <Box sx={{ flex: 1, overflowY: "auto" }}>
          <StackTelasFormFields
            formik={formik}
            mode={mode}
            setFieldValue={setFieldValue}
          />
        </Box>
        <Box
          sx={{
            px: 4, py: 2.5,
            borderTop: "1px solid rgba(244,63,94,0.15)",
            display: "flex", justifyContent: "flex-end", gap: 1.5,
            background: "#fff",
            ".dark &": { background: "#1e293b", borderColor: "rgba(244,63,94,0.2)" },
          }}
        >
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{
              fontFamily: "'Poppins', sans-serif", fontWeight: 600, borderRadius: 2,
              borderColor: "#f43f5e", color: "#f43f5e",
              "&:hover": { borderColor: "#e11d48", background: "#fff0f6" },
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            type="submit"
            sx={{
              fontFamily: "'Poppins', sans-serif", fontWeight: 600, borderRadius: 2,
              background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
              boxShadow: "0 4px 14px rgba(244,63,94,0.35)",
              "&:hover": { background: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
            }}
          >
            Guardar Rollo
          </Button>
        </Box>
      </Box>
    </FormikProvider>
  );
};

export default StackTelasForm;
